import { ActivityAuthorTypeEnum } from './activity-author-type.enum';
import { subEnum } from './sub-enum.helper';

export const UploadSourceAuthorTypeEnum = subEnum(ActivityAuthorTypeEnum, [
  ActivityAuthorTypeEnum.api,
  ActivityAuthorTypeEnum.user,
  ActivityAuthorTypeEnum.contact,
]);
export type UploadSourceAuthorTypeEnum =
  (typeof UploadSourceAuthorTypeEnum)[keyof typeof UploadSourceAuthorTypeEnum];
